import React, { Component } from "react";
import mainLogo from "../../assets/img/emersonLogo.jpg";
import "../../css/style.css";

class Home extends Component {
  render() {
    return (
      <div className="home-page">
        <div style={{ margin: "20px" }}>
          <img src={mainLogo} alt="" height={120} />
        </div>
        <div style={{ margin: "40px" }}>
          <h3>
            <a href="https://www.atar-success.com.au/">ATAR Seminar</a>
          </h3>
          <h3>
            <a href="/login">Dashboard</a>
          </h3>
        </div>
      </div>
    );
  }
}
export default Home;
